/* global Raven */
function captureError(error) {
  if (typeof Raven !== 'undefined' && Raven.captureException && error instanceof Error) {
    Raven.captureException(error);
  }
}

module.exports = {
  captureError,
};



// WEBPACK FOOTER //
// ./static/js/v0/utilities/raven.js